import { Container, Flex, Text, Heading, Grid, Box } from '@radix-ui/themes';
import { Image } from '@trashlab/sitesapp/src/organizations/denversiteworks/components/shared/image';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/denversiteworks/contexts/use-tenant-context';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/denversiteworks/lib/utils/get-variant-value';
import AnimatedTextBlock from '@trashlab/sitesapp/src/organizations/denversiteworks/components/shared/animated-text-block';

export function CommunityServiceSection() {
  const { website } = useTenantContext();

  const communityServiceSectionTitle = useVariantValue(
    'COMMUNITY_SERVICE_SECTION_TITLE',
    `Why our customers love us`,
  );

  const communityServiceTitle = useVariantValue(
    'COMMUNITY_SERVICE_TITLE',
    `Proudly serving ${
      website?.organization?.name || 'our company'
    } and its surrounding communities`,
  );

  const communityServiceSubtitle = useVariantValue(
    'COMMUNITY_SERVICE_SUBTITLE',
    `We're proud to offer our outstanding dumpster rental services to Salt Lake County and its nearby communities. Our reach extends beyond the county lines, delivering reliable, efficient, and affordable assistance to a diverse range of clients. From bustling city centers to surrounding neighborhoods, our team is committed to providing top-tier waste management solutions to meet your needs.`,
  );

  const communityServiceImage = useVariantValue(
    'COMMUNITY_SERVICE_IMAGE',
    '/default/community-service.svg',
  );

  return (
    <Container
      size="4"
      p="8"
      className={`relative min-h-[300px] overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[url('/default/rental-steps-bg.svg')] before:bg-cover before:bg-center before:bg-no-repeat before:opacity-100 before:-z-10 after:content-[''] after:absolute after:inset-0 after:opacity-90 after:-z-10`}
    >
      <Grid
        columns={{ initial: '1', md: '2' }}
        width="auto"
        justify="start"
        align="center"
        className="relative"
      >
        <Box
          className="order-2 md:order-1 overflow-visible relative no-animate"
          style={{ width: '100%' }}
        >
          <Box
            className="flex justify-center items-center"
            data-variable="COMMUNITY_SERVICE_IMAGE"
          >
            <Image
              src={communityServiceImage}
              alt="Community service"
              className="rounded-lg"
            />
          </Box>
        </Box>

        <AnimatedTextBlock className="order-1 md:order-2 z-10 m-4" delay={250}>
          <Flex direction="column" gap="4">
            <Text
              size="2"
              weight="bold"
              className="text-neutral-400"
              data-variable="COMMUNITY_SERVICE_SECTION_TITLE"
            >
              {communityServiceSectionTitle}
            </Text>

            <Heading as="h2" size="8" data-variable="COMMUNITY_SERVICE_TITLE">
              {communityServiceTitle}
            </Heading>

            <Text
              size="3"
              data-variable="COMMUNITY_SERVICE_SUBTITLE"
            >
              {communityServiceSubtitle}
            </Text>

          </Flex>
        </AnimatedTextBlock>
      </Grid>
    </Container>
  );
}

export default CommunityServiceSection;
